import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';

@Component({
  selector: 'lib-app-bridges-help',
  templateUrl: './bridges-help.component.html',
  styleUrls: ['./bridges-help.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, IonText],
})
export class BridgesHelpComponent implements PuzzleHelpDialogInjectableInterface {
  data: any;
  isMobile = false;
  translationKey = 'BRIDGES';

  constructor(private helperFunctions: HelperFunctionsService) {
    this.isMobile = this.helperFunctions.isMobileDevice();
  }

  setData(data: any): void {
    this.data = data;
  }
}
